import VMasker from 'vanilla-masker';
import { CPF_LENGTH, CPF_MASK, CNPJ_LENGTH, CNPJ_MASK } from '../Documents';

/**
 * Converts a value in kilograms to grams
 * @param {number} value - Value to be converted in kilograms
 * @returns {number} Value in grams
 */
function kilogramsToGrams(value) {
  value = value * 1000;
  return Number(value.toFixed(2));
}

/**
 * Formats phone number
 * 99999999999 to (99) 99999-9999 or (99) 9999-9999
 * @param {number|string} number - Number to be formats
 * @returns {string} - Formatted phone number
 */
function maskPhone(number) {
  return String(number).replace(/(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
}


/**
 * Formats document
 * 99999999999999 to 999.999.999-99 or 99.999.999/9999-99
 * depending on how many characters the string has
 * @param {number|string} number - Number to be formats
 * @returns {string} - Formatted phone number
 */

function formatDocument(value) {
  const valueLength = value.length;

  if(valueLength === CPF_LENGTH) {
    return VMasker.toPattern(value, CPF_MASK);
  }
  if (valueLength === CNPJ_LENGTH) {
    return VMasker.toPattern(value, CNPJ_MASK);
  }
  return value;
}

export {
  kilogramsToGrams,
  maskPhone,
  formatDocument
}
